import { render } from "./PasscodePopUp.vue?vue&type=template&id=0b78f1d6"
import script from "./PasscodePopUp.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PasscodePopUp.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script